import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { UserApiService } from '../../services/user-api.service';
@Component({
    selector: 'edit-user-details',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class EditUserDetails implements OnInit {
  @Input() role: string;
  @Input() userId: string;

  form!: FormGroup;
  public loading = false;
  private user;
  public error: string;
  public userId$: BehaviorSubject<string> = new BehaviorSubject(null);

  private currentStatus: string;

  constructor(
    public userService: UserApiService,
    private fb: FormBuilder,
    public router: Router
  ) {}

  ngOnInit(): void {
    (this.form = this.fb.group({
      id: [null, null],
      first_name: [null, null],
      last_name: [null, null],
      email: [null, [Validators.required]],
      admin_email: [null, [Validators.email]],
      branch_number: [null, [Validators.required]],
      employee_number: [null, [Validators.required]],
      status: [null, null],
    })),
      this.userId !== 'new' && this.loadUser(this.userId);
  }

  async loadUser(userId) {
    this.user = await this.userService.getUser(userId, this.role);
    const {
      firstName,
      lastName,
      email,
      adminEmail,
      branchNumber,
      employeeNumber,
      cohorts,
    } = this.user;
    this.form.patchValue({
      first_name: firstName,
      last_name: lastName,
      email,
      admin_email: adminEmail ?? this.user.admin_email ?? null,
      branch_number: branchNumber,
      employee_number: employeeNumber,
    });

    this.form.controls['status'].addValidators(Validators.required);
    this.currentStatus = cohorts[0].slug;
    this.form.patchValue({ status: this.currentStatus });
  }

  async onSubmit() {
    try {
      this.error = null;
      this.loading = true;

      const {
        first_name,
        last_name,
        status,
        email,
        admin_email,
        branch_number,
        employee_number,
      } = this.form.getRawValue();

      let data: any = {
        first_name,
        last_name,
        email,
        admin_email,
        branch_number: branch_number,
        employee_number: employee_number,
        cohorts: status,
      };

      if (this.user) {
        data.id = this.user.id;
      }

      this.userService.update(data, this.role).then(
        (response) => {
          this.router
            .navigate([`user/${response.id}`], {
              queryParams: { role: this.role },
            })
            .then(() => this.loadUser(response.id));

          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.handleError(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
  }

  private handleError(error: string) {
    this.error = error;
  }
}
